export enum AppStatusActionTypes {
    START_APP_INITIALIZATION = "START_APP_INITIALIZATION",
    COMPLETE_APP_INITIALIZATION = "COMPLETE_APP_INITIALIZATION",
    AUTHENTICATE_USER = "AUTHENTICATE_USER",
    FAIL_AUTHENTICATION = "FAIL_AUTHENTICATION",

    // Test
    UPDATE_COUNTER = "UPDATE_COUNTER"
}